<mat-card class="example-card">
    <mat-card-header>
        <div mat-card-avatar class="example-header-image"></div>
        <mat-card-title>Sección de médicos</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form" [formGroup]="form">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <!-- (blur)="editCompanyData(28);" -->
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{ 'WIZARD.DATOSDOCTORES.NOMBRE' | translate}}</mat-label>
                    <input matInput type="text" id="doctorName" name="doctorName" formControlName="doctorName">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'WIZARD.DATOSDOCTORES.ERROR.ERR01' | translate}}</mat-error>
                </mat-form-field>
            </div>



            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <!-- (blur)="editCompanyData(28);" -->
                <mat-form-field appearance="outline" fxFlex="45">
                    <mat-label>{{ 'WIZARD.DATOSDOCTORES.CEDULA' | translate}}</mat-label>
                    <input matInput formControlName="cedula" id="cedula" type="text" autocomplete="off">
                    <mat-icon matSuffix class="secondary-text">chrome_reader_mode</mat-icon>
                    <mat-error>{{'WIZARD.DATOSDOCTORES.ERROR.ERR01' | translate}}</mat-error>
                </mat-form-field>


                <mat-form-field appearance="outline" fxFlex="465" class="pl-4">
                    <mat-label>{{ 'WIZARD.DATOSDOCTORES.ESPECIALIDAD' | translate}}</mat-label>
                    <input matInput formControlName="especialidad" id="especialidad" type="text" autocomplete="off">
                    <mat-icon matSuffix class="secondary-text">school</mat-icon>
                    <mat-error>{{'WIZARD.DATOSDOCTORES.ERROR.ERR01' | translate}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pl-4">
                    <mat-label>{{ 'WIZARD.DATOSDOCTORES.CURP' | translate}}</mat-label>
                    <input matInput formControlName="curp" id="curp" type="text" autocomplete="off">
                    <mat-icon matSuffix class="secondary-text">chrome_reader_mode</mat-icon>
                    <mat-error>{{'WIZARD.DATOSDOCTORES.ERROR.ERR01' | translate}}</mat-error>
                </mat-form-field>

            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="49" class="pl-4">
                    <mat-label>{{ 'WIZARD.DATOSDOCTORES.EMAIL' | translate}}</mat-label>
                    <input matInput formControlName="correo" id="correo" type="text" autocomplete="off">
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                    <mat-error>{{'WIZARD.DATOSDOCTORES.ERROR.ERR01' | translate}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="49" class="pl-4">
                    <mat-label>{{ 'WIZARD.DATOSDOCTORES.TELEFONO' | translate}}</mat-label>
                    <input matInput formControlName="telefono" id="telefono" type="text" autocomplete="off">
                    <mat-icon matSuffix class="secondary-text">contact_phone</mat-icon>
                    <mat-error>{{'WIZARD.DATOSDOCTORES.ERROR.ERR01' | translate}}</mat-error>
                </mat-form-field>
            </div>
            <!--<mat-icon mat-font-icon="fa-icon" class="fa"></mat-icon><div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="95">
                    <mat-label>{{ 'WIZARD.DATOSDOCTORES.DOMICILIO' | translate}}</mat-label>
                    <textarea matInput formControlName="domicilio" id="domicilio" name="domicilio" type="text"></textarea>
                    <mat-icon matSuffix class="secondary-text">business</mat-icon>
                    <mat-error>{{'WIZARD.DATOSDOCTORES.ERROR.ERR01' | translate}}</mat-error>
                </mat-form-field>

            </div>-->

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'WIZARD.DATOSDOCTORES.CT' | translate}}</mat-label>
                    <mat-select formControlName="workcenter" id="workcenter">
                        <mat-option *ngFor="let CT of centrosTrabajoArray" [value]="CT.centro.id_CT" (click)="valSelect(CT.centro._id,CT.centro.id_CT,CT.centro.nombre_CT);">
                            <!-- {{institute.regionInstituto}} -->
                            {{CT.centro.nombre_CT}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">domain</mat-icon>
                    <mat-error>{{'WIZARD.DATOSDOCTORES.ERROR.ERR01' | translate}}</mat-error>
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>
    <mat-card-actions>
        <div fxLayout="row" fxLayoutAlign="space-evenly center">
            <button mat-button (click)="onNoClick()">{{'WIZARD.DATOSDOCTORES.ACCIONES.LABEL04' | translate}}</button>
            <button mat-button (click)="saveData();">{{'WIZARD.DATOSDOCTORES.ACCIONES.LABEL03' | translate}}</button>
        </div>
    </mat-card-actions>
</mat-card>